import { ROUTES } from '#/config/routes';

/**
 * 只使用這一筆自己的三個單據 id。沒有報告顯示「尚未建立」；沒有簽收不給連結。
 * @param {object | null | undefined} item
 */
export function getRepairItemDocumentLinks(item) {
  const repairRequestId = item?.repairRequestId;
  const repairReportId = item?.repairReportId;
  const signReceiptId = item?.signReceiptId;

  return {
    repairRequestTo: repairRequestId ? ROUTES.repairRequestDetail(repairRequestId) : null,
    repairReportTo: repairReportId ? ROUTES.repairReportDetail(repairReportId) : null,
    repairReportEmptyLabel: '尚未建立',
    signReceiptTo: signReceiptId ? ROUTES.signReceiptDetail(signReceiptId) : null,
  };
}
